import { render, staticRenderFns } from "./Unvocalized.vue?vue&type=template&id=c0dc378e"
import script from "./Unvocalized.vue?vue&type=script&lang=js"
export * from "./Unvocalized.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports